import Script from 'next/script';
import { getEnvs } from '@/helpers/getEnvs';

// L4QXSs houseRegister script
// 738x4G support script
const appEnvironment = getEnvs()?.APP_ENVIRONMENT;
const isWhiteLabel = appEnvironment === 'violet';
const GoftinoLoader = () => {
  const widgetId = isWhiteLabel ? '05Ur0R' : '738x4G';
  return <Script id="goftino" strategy="afterInteractive" dangerouslySetInnerHTML={{
    __html: `
          (function () {
            var i = "${widgetId}";
            var d = document;

            var g = d.createElement("script");
            var s = "https://www.goftino.com/widget/" + i;
            var l = localStorage.getItem("goftino_" + i);

            g.async = true;
            g.defer = true;
            g.src = l ? s + "?o=" + l : s;

            d.head.appendChild(g);
          })();
        `
  }} data-sentry-element="Script" data-sentry-component="GoftinoLoader" data-sentry-source-file="GoftinoLoader.tsx" />;
};
export default GoftinoLoader;